<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      同乐南站<br>
站点介绍<br>
位于南山区的前进路与南坪快速路的交叉口，沿前进路呈东西向布置。车站周边主要分布了了南山农批市场、南山供电局、豪方天际花园、南联社区服务中心等地。为地下两层岛式车站，地下一层为站厅层，地下二层为站台层。（地下一层为站厅层，地下二层为设备层，地下三层为站台层）<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:27	23:23	12号线	4分钟	8分钟<br>
海上田园东	06:25	23:49	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:31	23:23	12号线	8分钟	8分钟<br>
海上田园东	06:26	23:49	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A出入口:<br>
前进路东侧（北）、南山农批市场、南山家禽批发市场、尚璟公馆(物业建设中)<br><br>
B出入口:<br>
前进路西侧（北）<br><br>
C出入口:<br>
前进西侧（南）、南山供电局、南头海关缉私分局、深圳市宝安区财政局、深圳市宝安建筑设计院、华府国际、南富苑、南头海关生活区、南山意境、宝恒宿舍、南头边检生活小区<br><br>
D出入口:<br>
前进路东侧（路南）、南联社区党群服务中心、南山农产品批发市场、南山实验教育集团园丁学校、豪方天际花园、前海东岸花园<br>
公交换乘信息<br><br>

  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>